import moment from 'moment/src/moment'
export default {
  install(Vue) {
    Vue.prototype.$format = {
      replaceDotWithComma(value) {
        if (value === null || value === undefined || value === "") return ""
        return parseFloat(value)
          .toFixed(2)
          .toString()
          .replace(".", ",")
      },
      replaceDotWithCommaWOFixed(value) {
        if (value === null || value === undefined || value === "") return ""
        return value.toString().replace(".", ",")
      },
      replaceCommaWithDot(value) {
        if (!value) return null
        return value.toString().replace(",", ".")
      },
      replaceCommaWithDotCal(value) {
        if (!value) return 0
        return parseFloat(value.toString().replace(",", "."))
      },
      cloneVariable(data) {
        if (!data) return null
        return JSON.parse(JSON.stringify(data))
      },
      filterDate(date) {
        if (!date) return null
        return moment(date, "DD.MM.YYYY").isValid() ? moment(date, "DD.MM.YYYY").format("DD.MM.YYYY") : null
      },
      formatDate(date, fromFormat, toFormat) {
        if (!date) return null
        return moment(date, fromFormat).isValid() ? moment(date, fromFormat).format(toFormat) : null
      },
      isNullOrEmpty(val) {
        return val === undefined || val === null || val === ""
      },
      isNull(val) {
        return val === null
      },
      isEmptyObject(obj) {
        return Object.entries(obj).length === 0 && obj.constructor === Object
      },
      isArrayHasData(array) {
        if (array && array.length > 0) return true
        else return false
      },
      getRandomNumberInBW(min, max) {
        return parseInt(Math.random() * (max - min) + min)
      },
      debounce(func, delay) {
        let debounceTimer
        return function() {
          const context = this
          const args = arguments
          clearTimeout(debounceTimer)
          debounceTimer = setTimeout(() => func.apply(context, args), delay)
        }
      },
      // _getSumBy([4, 2, 8, 6]) // 20
      getSum(arr) {
        return [...arr].reduce((acc, val) => acc + val, 0)
      },
      // _getSumBy([{ n: 4 }, { n: 2 }, { n: 8 }, { n: 6 }], x => x.n) // 20
      getSumBy(arr, fn) {
        const self = this
        if (this.isArrayHasData(arr)) {
          return arr.map(typeof fn === "function" ? fn : (val) => val[fn]).reduce(function(acc, val) {
            return self.replaceCommaWithDotCal(acc) + self.replaceCommaWithDotCal(val)
          }, null)
        } else return null
      },
      validEmail(email) {
        // eslint-disable-next-line no-useless-escape
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      },
      getCurrentDate() {
        return moment(new Date()).format("DD.MM.YYYY")
      },
      groupBy(array, key) {
        return array.reduce(function(total, item) {
          total[item[key]] = total[item[key]] || []
          total[item[key]].push(item)
          return total
        }, {})
      },
      // _findValueInArray([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b === 10) // { n: 4, b: 10 }
      findValueInArray(array, condition) {
        const getObj = array.find(condition)
        if (getObj) return getObj
        else return null
      },
      // _getSingleValueFromObject([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b) // [10, 11]
      mapDataInArray(array, condition) {
        const getObj = array.map(condition)
        if (getObj) return getObj
        else return null
      },
      /* {
          number: { list:['qty', 'price'], format: 'replaceCommaWithDot' },
          date: { list:['start', 'end'], from: 'DD.MM.YYYY', to: 'YYYY.MM.DD'},
          status: { list:['status'], text: '', value: '$_ccsheetStatus' },
          merge: { list:['firstname', 'lastname'], property: 'username' }
      */
      formatModel(model, data) {
        model = JSON.parse(JSON.stringify(model))
        const keys = Object.keys(data)
        keys.forEach((key) => {
          switch (key) {
            case "number": {
              const formatObj = data.number
              formatObj.list.forEach((item) => {
                model[item] = this[formatObj.format](model[item])
              })
              break
            }
            case "date": {
              const formatObj = data.date
              formatObj.list.forEach((item) => {
                const dateObj = this.formatDate(model[item], formatObj.from, formatObj.to)
                model[item] = dateObj
              })
              break
            }
            case "status": {
              const formatObj = data.status
              formatObj.forEach((item) => {
                const statusArray = this[item.value]
                statusArray.map(function(x) {
                  if (x.value === model[item]) model[item] = { text: x.text, value: model[item] }
                })
              })
              break
            }
            default:
              break
          }
        })
        return model
      },
      // Array of $_formatModel FUNCTION
      formatListModel(listOfModel, data) {
        if (this.isArrayHasData(listOfModel)) {
          const result = []
          listOfModel.forEach((model) => {
            result.push(this.formatModel(model, data))
          })
          return result
        } else return []
      },
      sortByType(item1, item2) {
        if (typeof item1 === "string" && typeof item2 === "string") {
          if (/^\d+$/.test(item2) && /^\d+$/.test(item1)) {
            return item1.localeCompare(item2, undefined, {
              numeric: true
            })
          }
          return item1.localeCompare(item2)
        } else {
          return item1 < item2 ? -1 : 1
        }
      },
      // Array format and parse number
      formatAndParseList(list, listOfValues, methodName) {
        if (list.length > 0) {
          const result = []
          list.forEach((element) => {
            result.push(this.formatAndParseModel(element, listOfValues, methodName))
          })
          return result
        } else return []
      },
      // Object format and parse numbers
      formatAndParseModel(model, listOfValues, methodName) {
        const modelData = this.cloneVariable(model)
        listOfValues.forEach((element) => {
          modelData[element] = parseFloat(this[methodName](modelData[element]))
        })
        return modelData
      },
      customSorting(items, index, isDesc, dateColumnArray, type) {
        items.sort((a, b) => {
          if (dateColumnArray.includes(index)) {
            const date1 = a[index]
            const date2 = b[index]
            if (!isDesc) {
              return this.sortWithDates(date1, date2, type)
            } else {
              return this.sortWithDates(date2, date1, type)
            }
          } else {
            if (!a[index]) a[index] = ""
            if (!b[index]) b[index] = ""
            if (!isDesc) {
              return this.sortByType(a[index], b[index])
            } else {
              return this.sortByType(b[index], a[index])
            }
          }
        })
        return items
      },
      sortWithDates(date1, date2, type) {
        if (date1 === "" || date1 === null) return -1
        if (date2 === "" || date2 === null) return 1
        const dateA = moment(date1, type)
        const dateB = moment(date2, type)
        return dateA - dateB
      },
      // Set Foreground color based on the background color
      foreGroundColor(colorValue) {
        const rgbCode = colorValue ? this.hexToRgbA(colorValue) : ""
        const color = rgbCode ? rgbCode.toString().split("(")[1] : ""
        const resultOnColor = color.split(",", 3)
        const R = resultOnColor[0]
        const G = resultOnColor[1]
        const B = resultOnColor[2] ? resultOnColor[2].toString().replace(")", "") : 0
        const C = [R / 255, G / 255, B / 255]
        for (var i = 0; i < C.length; ++i) {
          if (C[i] <= 0.03928) {
            C[i] = C[i] / 12.92
          } else {
            C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
          }
        }
        const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]
        if (L > 0.179) {
          return "black"
        } else {
          return "white"
        }
      },
      hexToRgbA(hex) {
        hex = hex.slice(0, -2)
        var c
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          c = hex.substring(1).split("")
          if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
          }
          c = "0x" + c.join("")
          return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",1)"
        }
        return null
      },
      stringToProperCase(value) {
        return value
          .toLowerCase()
          .split("_")
          .map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1)
          })
          .join("_")
      },
      getHumanzieTime(time) {
        return moment(time, "DD.MM.YYYY HH:mm:ss").isValid() ? moment(time, "DD.MM.YYYY HH:mm:ss").fromNow() : null
      },
      fixedNumbers(value) {
        if (value === null || value === undefined || value === "") return 0
        return +parseFloat(value).toFixed(2)
      },
      slugify(value, spacer = "-") {
        if (value === null || value === undefined || value === "") return value

        var slug = ""
        var titleLower = value.toLowerCase()
        slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e")
        slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a")
        slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o")
        slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u")
        slug = slug.replace(/đ/gi, "d")
        slug = slug.replace(/\s*$/g, "")
        slug = slug.replace(/\s+/g, spacer)

        return slug
      },
      /* Adjustabale signature hight size */
      $_setSignaturePadHeight(item) {
        let height = 250
        height = [2, 1].includes(item.columns) ? 50 : item.columns * 21
        return height
      }
    }
  }
}
